<template>
    <a-modal 
        :width="props.width" 
        v-model:visible="props.show" 
        centered 
        :title="props.showData.title" 
        @cancel="cancel"
    >
      <div class="content_box">
        <slot name="content">
            <div style="white-space: pre-line;" v-html="props.showData.content"></div>
        </slot>
      </div>
      <template #footer>
        <div class="btn_box">
            <a-button style="margin-right: 5px;" v-if="props.cancelText" @click="cancel">{{props.cancelText}}</a-button>
            <a-button type="primary" v-if="props.okText" @click="handleOk" :loading="props.loading">{{props.okText}}</a-button>
        </div>
      </template>
    </a-modal>
</template>

<script setup>
import { ref } from "vue"; 
const props = defineProps({
    width: {
        type: Number || String,
        default: 750
    }, 
    show: {
        type: Boolean,
        default: false
    }, 
    showData: {
        type: Object,
        default: ()=>{
            return {
                title: "",
                content: "", 
            }
        }
    },
    cancelText: {
        type: [String, Boolean],
        default: "取消"
    }, 
    okText: {
        type: String || Boolean,
        default: "确定"
    },
    loading: {
        type: Boolean,
        default: false
    }
})
const emit = defineEmits([ "update:show", "okChange", "cancel" ])


function handleOk() {
    // console.log("点击确定按钮==");
    emit("okChange", cancel)
}

function cancel() {
    emit("update:show", false); 
    emit("cancel")
}

</script>

<style lang="less" scoped>
.content_box {
    width: 100%;
    min-height: 200px;
    max-height: 70vh;
    overflow: auto;
    .btn_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

</style>